import {
  Accordion as AccordionBase,
  AccordionDetails as AccordionDetailsBase,
  AccordionSummary as AccordionSummaryBase,
  accordionSummaryClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import PageMarginsBase from '@/components/ui/PageMargins/PageMargins';

export const PageMargins = styled(PageMarginsBase)(({ theme }) => ({
  marginBottom: theme.spacing(12),
}));

export const Accordion = styled(AccordionBase)(({ theme }) => ({
  borderRadius: 5,
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  marginBottom: `${theme.spacing(2)} !important`,

  '&:before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled(AccordionSummaryBase)(({ theme }) => ({
  minHeight: 'auto !important',
  [`.${accordionSummaryClasses.content}`]: {
    margin: `${theme.spacing(1.5, 0)} !important`,
  },
}));

export const AccordionDetails = styled(AccordionDetailsBase)(({ theme }) => ({
  paddingTop: 0,
  paddingLeft: theme.spacing(4),
  color: theme.palette.text.secondary,

  '*': {
    ...theme.typography.body1Redesign,
  },

  a: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));
